import { atom } from "recoil"

export const AtomCurrentBadge2Url = atom({
    key:'ATOMBADGE2URl',
    default:''
})
  